module.exports = __webpack_public_path__ + "img/page-01.e6821cbe.png";